<template>
  <main>
    <marketing-email-list />
  </main>
</template>

<script>
import MarketingEmailList from "@components/modules/marketing/email/list/MarketingEmailList";

export default {
  components: {
    MarketingEmailList,
  },

  data() {
    return {};
  },

  mounted() {
    sessionStorage.removeItem("email_item");
    sessionStorage.removeItem("email_data");
    sessionStorage.removeItem("email_step");
  },

  beforeCreate() {},

  computed: {},

  mixins: [],
};
</script>

<style lang="scss" scoped>
</style>
